// src/api/feedbackApi.js
import apiClient from './axios';

const feedbackApi = {
  // GET all feedbacks (with pagination + search)
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/feedbacks/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // GET by ID
  getById: async (id) => {
    const response = await apiClient.get(`/feedbacks/${id}/`);
    return response.data;
  },

  // MARK AS READ / UNREAD
  markRead: async (id, is_read = true) => {
    const response = await apiClient.patch(`/feedbacks/${id}/mark_read/`, { is_read });
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/feedbacks/${id}/`);
    return id;
  },
};

export default feedbackApi;